import { createFileRoute } from '@tanstack/react-router';
import { EmployeeTraining } from '@/modules/employee-training';

export const Route = createFileRoute('/(dashboard)/_dashboard/employee-training')({
  component: EmployeeTraining,
});
